module.exports = __webpack_public_path__ + "img/main.9f714c40.jpeg";